export default __webpack_public_path__ + "static/media/car.198c8835.svg";